export const client = {
  presidente: "Cerveza Presidente",
  drLogic: "DrLogic",
  descubria: "Descubria",
  capitalDBG: "Capital",
  miguelRivas: "Miguel Rivas",
  pepsi: "Pepsi",
  redRock: "Red Rock",
  itla: "ITLA",
  pixelPerfectTree: "Pixel Perfect Tree",
  bprBank: "BPR Bank",
  voxel: "Voxel Cube Games",
  orange: "Orange",
  apap: "APAP",
  enovational: "Enovational",
  socialNetwork: "Social Network",
  jellyfish: "Jellyfish",
  plantTherapy: "Plant Therapy",
  avante: "Avante Marketing",
  delJardin: "Pasteleria del Jardin",
  cosplayDominicano: "Cosplay Dominicano",
  highschool: "Highschool.com.do",
  outback: "Outback Steakhouse",
  tiempoExtra: "TiempoExtra",
  homeGallery: "Home Gallery",
  sdq: "SDQ Training Center",
  harinaBlanquita: "Harina Blanquita",
  mangoBajito: "Mango Bajito",
  codepen: "Codepen",
  studioSeveral: "Studio Several",
  itesa: "ITESA",
  teamUp: "TeamUp",
};